import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Checkbox,
  CircularProgress,
  TextField,
  Box,
  IconButton,
  Grid,
  Typography,
  TextareaAutosize,
  FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import { ReactComponent as CrossIcon } from "Assets/Icons/CrossIcon.svg";
import {
  START_COLLECTED_AND_REMOVED_MEDICATION,
  START_COLLECT_AND_REMOVE_MEDICATION,
  START_DELETE_NOTE,
  START_GET_COLLECTION_COUNT,
  RESET_COLLECTION_STATE,
  RESET_COLLECTED_AND_REMOVED_MEDICATION,
} from "Actions/CollectionAction";
import { connect, useSelector } from "react-redux";
import * as yup from "yup";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import "../../Sass/Common.scss";
import Button from "Components/Common/Button/Button";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import PageLoading from "Components/Common/PageLoading";
import moment from "moment";
import { START_GET_HOME_LIST } from "Actions/HomeAction";
import clsx from "clsx";
import { capitalizeFirstLetter, getLocalStorage } from "utils/generalUtils";
import { ReactComponent as EditIcon } from "Assets/Icons/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "Assets/Icons/DeleteIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import EditDrugDialog from "Components/Common/Dialog/EditDrugDialog";
import useViewport from "Hooks/useViewport";
import ConfirmationDialog from "Components/Common/Dialog/ConfirmationDialog";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";
import { ReactComponent as NoteTextIcon } from "Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import { ReactComponent as ModalCloseIcon } from "Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import { ReactComponent as CollectedRXIcon } from "Assets/Icons/CollectRx.svg";
import { ReactComponent as PersonIcon } from "Assets/Icons/personICon.svg";
import { ReactComponent as CalenderIcon } from "Assets/Icons/Calender.svg";
import { ReactComponent as EditPencleIcon } from "Assets/Icons/editp.svg";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
const RemoveMedicationConfirmationDialog = React.lazy(() =>
  import("Components/Collection/RemoveMedicationConfirmationDialog")
);
const ConfirmDateCollectedDialog = React.lazy(() =>
  import("Components/Collection/ConfirmDateCollectedDialog")
);

const useStyle = makeStyles((theme) => ({
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      borderRadius: "26px",
      [theme.breakpoints.down("1112")]: {
        maxWidth: "75% !important",
      },
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    // padding: "0",
    // maxHeight: " calc(100vh - 405px) !important",
    maxHeight: "calc(60vh - 174px) !important",
    padding: " 0 !important",
    "&>table": {
      borderRadius: "5px",
      border: "1px solid #EDEDED !important",
      "&>thead": {
        "&>tr": {
          // border: "1.5px solid red !important",
          "&>th": {
            padding: "0px 6px !important",
            // borderTop: "none !important",
            borderBottom: "1px solid #EDEDED !important",
            borderTop: "1px solid #EDEDED !important",
            borderLeft: "none !important",
            borderRight: "none !important",
            outline: "none !important",
          },
        },
      },
      "&>tbody": {
        "&>tr": {
          // border: "1.5px solid red !important",
          "&>td": {
            padding: "6px !important",
            outline: "none !important",
            // border: "none !important",
            borderLeft: "none !important",
            borderRight: "none !important",
            borderBottom: "1px solid #EDEDED",
          },
        },
      },
    },
  },
  medicationErrorMessage: {
    color: theme.palette.error.main,
    width: "100%",
    textAlign: "center",
    paddingLeft: "10px",
    fontSize: "12px",
    whiteSpace: "nowrap !important",
  },
  tableAlign: {
    color: "black !important",
    padding: "10px !important",
    border: "none !important",
  },
  textJustify: {
    color: "black !important",
    padding: "10px !important",
    border: "none !important",
    paddingLeft: "10px !important",
    paddingRight: "0px !important",
    whiteSpace: "nowrap !important",
  },
  align: {
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  alignmentCheck: {
    // display: "flex !important",
    // position: "inherit !important",
    // alignItems: "center !important",
    // justifyContent: "center !important",
    // color: "rgb(0, 0, 0) !important",
    // backgroundColor: "rgb(217, 217, 217) !important",
  },
  rsStatus: {
    backgroundColor: "rgb(220 241 204) !important",
    border: `0.5px solid ${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main}!important`,
    borderRadius: "5px",
    width: "90px",
  },
  rsPatientName: {
    padding: "10px !important",
    color: "rgb(0, 0, 0) !important",
    fontWeight: "700 !important",
  },
  rsPatientNamePadding: {
    padding: "10px !important",
    color: "rgb(0, 0, 0) !important",
    fontWeight: "700 !important",
    // marginLeft: "18px !important",
    marginLeft: "0px !important",
    paddingLeft: "0px !important",
    alignItems: "center",
    display: "flex",
    "&>svg": {
      marginLeft: "3px",
      marginRight: "8px",
    },
  },
  rsDeleteText: {
    color: "rgba(255, 68, 51,0.9) !important",
    // backgroundColor: "rgb(217, 217, 217) !important",
  },
  rstextButton: {
    whiteSpace: "nowrap !important",
    marginLeft: "-10px !important",
    "&:hover": {
      background: "transparent !important",
      textDecoration: "underline !important",
    },
  },
  rsOrderDate: {
    color: "black !important",
    "&>div": {
      "&>div": {
        "&>button": {
          marginLeft: "5px !important",
        },
      },
    },
    "&:hover": {
      lineHeight: "20px",
      cursor: "pointer",
      "&>div": {
        "&>div": {
          "&>button": {
            padding: "0px !important",
            "&:hover": {
              backgroundColor: "transparent !important",
              border: `none !important`,
            },
            "&>svg": {
              display: "block",
            },
          },
        },
      },
    },
  },
  rsTextColor: {
    lineHeight: "10px !important",
    color: "black !important",
  },
  rseditDateIcon: {
    padding: "0px !important",
    width: "18px",
    height: "18px",
    "&>svg": {
      "&>path": {
        fill: "rgb(123,192,68)",
        stroke: "white",
      },
      // marginLeft: 10,
      display: "none",
    },
  },
  rsAlign: {
    display: "inline-flex !important",
    alignItems: "center !important",
  },
  rsCollectedNumber: {
    width: "55px !important",
    "&>div": {
      "&>input": {
        padding: "0px 10px !important",
        textAlign: "center",
        color: "black !important",
        minWidth: "45px",
      },
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth":
    {
      borderRadius: "5px !important",
    },
  },
  rsBtnMain: {
    "&>button": {
      // borderRadius: "19px !important",
    },
  },
  rstextFieldsize: {
    width: "55px !important",
    "&>div": {
      "&>input": {
        minWidth: "45px",
        padding: "0px 10px !important",
        textAlign: "center",
        color: "black !important",
      },
    },
  },
  rsheader: {
    // color: "rgb(0, 0, 0) !important",
    // backgroundColor: "rgb(217, 217, 217) !important",
  },
  rsRedTest: {
    color: "#e9514e !important",
    position: "absolute",
    display: "block",
    fontSize: "12px !important",
    [theme.breakpoints.down("850")]: {
      whiteSpace: "nowrap !important",
    },
  },
  rsBoxAlign: {
    position: "relative",
    width: "590px",
  },
  rsCollectedDate: {
    alignItems: "center",
    // backgroundColor: `${theme.palette.primary.main}80`,
    color: "black",
    display: "flex",
    height: "20px",
    fontWeight: "600",
    color: "#5A6872",
  },
  rsCollectionNote: {
    display: "flex !important",
    paddingBottom: "5px !important",
  },
  rsBackground: {
    background: "#FAF4F4",
    borderRadius: "5px !important",
    height: "auto",
    padding: "10px !important",
    width: "100% !important",
    color: " black !important",
  },
  rsFontColor: {
    color: "black !important",
  },
  iconBtn: {
    zIndex: "2 !important",
    marginTop: "3px !important",
    borderRadius: "10% !important",
    "&>svg": {
      "&>path": {
        fill: "rgb(123,192,68)",
        stroke: "rgb(123,192,68)",
      },
    },
  },
  iconBtnEdit: {
    zIndex: "2 !important",
    marginTop: "3px !important",
    borderRadius: "10% !important",
    "&>svg": {
      "&>path": {
        // fill: "rgb(123,192,68)",
        // stroke: "rgb(123,192,68)",
      },
    },
  },
  rsTextAreaBox: {
    margin: "5px",
    "&>button": {
      float: "right",
    },
    "&>textarea": {
      width: "100%",
    },
  },
  rsTextArea: {
    resize: "none",
    fontFamily: "Poppins",
    color: theme.palette.secondary.main,
    marginTop: "15px !important",
    paddingLeft: "5px !important",
    padding: "10px",
    "&:focus ": {
      borderColor: "black !important",
      outline: "none !important",
      // boxShadow: "none !important",
    },
  },
  rsTextAreaEdit: {
    resize: "none",
    fontFamily: "Poppins",
    color: theme.palette.secondary.main,
    // marginTop: "15px !important",
    paddingLeft: "5px !important",
    padding: "10px",
    "&:focus ": {
      borderColor: "black !important",
      outline: "none !important",
      // boxShadow: "none !important",
    },
  },
  buttonStyle: {
    marginTop: "-10px ",
  },
  orderdateMain: {
    display: "flex",
    alignItems: "center",
    "&>svg": {
      marginRight: "5px",
    },
    "&>h4": {
      color: "black !important",
      fontSize: "18px !important",
      fontWeight: "500 !important",
    },
  },
  Removeborder: {
    borderTop: "none",
  },
  orderDate: {
    marginLeft: "25px !important",
    fontSize: "16px",
    fontWeight: "400 !important",
    marginRight: "5px",
    height: "27px",
  },
  rsDate: {
    opacity: "0",
    width: "min-content !important",
    marginLeft: "93px !important",
    "&>div": {
      padding: "0px !important",
      marginTop: "-44px",
      fontFamily: "Poppins,sans-serif",
      "&>input": {
        fontSize: "13px !important",
        padding: "0px !important",
        // opacity: "0",
      },
      "&>fieldset": {
        // display: "none",
      },
    },
  },
  rsArrived: {
    opacity: "0",
    width: "min-content !important",
    marginLeft: "-32px !important",
    "&>div": {
      padding: "0px !important",
      // marginTop: "-44px",
      fontFamily: "Poppins,sans-serif",
      "&>input": {
        fontSize: "13px !important",
        padding: "0px !important",
        // opacity: "0",
      },
      "&>fieldset": {
        // display: "none",
      },
    },
  },
}));

const CollectDialog = ({
  open,
  setOpen,
  collectionViewRxAction,
  collectionViewRxDetails,
  collectAndUncollectedViewRxDetails,
  collectAndRemoveMedicationAction,
  collectedAndRemovedMedicationAction,
  collectedAndRemovedData,
  collectAndRemoveData,
  getCollectionCountAction,
  collectionListCount,
  getHomeListAction,
  collectedUncollectedListShow,
  selectedNoteDetails,
  setNoteId,
  deleteNoteAction,
  deleteSingleNote,
  addAndUpdateNoteAction,
  addAndUpdateNote,
  subscriptionDialog,
  setSubscritionDialog,
  resetCollectedAndRemovedMedicationAction,
}) => {
  const classes = useStyle();
  const formState = {
    discontinue_number: null,
    collected_number: null,
    order_delay_date: "",
  };
  const [openMedicationRemoveConfirm, setOpenMedicationRemoveConfirm] =
    useState(false);
  const [collectMedication, setCollectMedication] = useState([]);
  const [deleteMedication, setDeleteMedication] = useState([]);
  const [medicationErrorStatus, setMedicationErrorStatus] = useState(false);
  const [collectedErrorStatus, setCollectedErrorStatus] = useState(false);
  const [removedErrorStatus, setRemovedErrorStatus] = useState(0);
  const [collect, setCollect] = useState("");
  const [removed, setRemoved] = useState("");
  let tempCollected = 0;
  let tempRemoved = 0;

  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);
  const [openConfirmDate, setOpenConfirmDate] = useState(false);
  const [preferredOrderLateYes, setPreferredOrderLateYes] = useState(false);
  const [preferredOrderLateNo, setPreferredOrderLateNo] = useState(false);
  const [isOpenOption, setIsOpenOption] = useState(false);
  const [isOpenStopAndDiscontinued, setIsOpenStopAndDiscontinued] =
    useState(false);
  const [orderDate, setOrderDate] = useState(new Date());
  const [nextOrderDate, setNextOrderDate] = useState();
  const [orderDelayDate, setOrderDelayDate] = useState(null);
  const [serverSideErrors, setServerSideError] = useState({});
  const [isOpenDrugDialog, setIsOpenDrugDialog] = useState(false);
  const [editDrugName, setEditDrugName] = useState({});
  const { width } = useViewport();
  const [medications, setMedication] = useState(
    collectionViewRxDetails?.data?.patient_medications
  );
  const [mediCount, setMediCount] = useState("");
  const [mediCollectedCount, setMediCollectedCount] = useState("");
  const [totalMedi, setTotalMedi] = useState("");
  const [duplicateDrug, setDuplicateDrug] = useState([]);
  const [removeDrugList, setRemoveDrugList] = useState([]);
  const [lastDrug, setLastDrug] = useState(false);
  const [showTextField, setShowTextField] = useState(false);
  const [deleteNoteData, setDeleteNoteData] = useState(false);
  const [showTextFieldOrderDate, setShowTextFieldOrderDate] = useState(false);
  const [openOrderDatePicker, setOpenOrderDatePicker] = useState(false);
  const [openArriedDatePicker, setOpenArriedDatePicker] = useState(null);
  const [medicationfirst, setMedicationfirst] = useState(false);
  const [noteValue, setNoteValue] = useState("");
  const [error, setError] = useState(false);
  const [dateValidetionErrorStatus, setDateValidetionErrorStatus] =
    useState(false);
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user
  );
  const showDataBasedOnRole = loginUserDetail?.data?.data?.role;

  const formStatenote = {
    note: selectedNoteDetails?.note,
  };
  const [noteData, setNoteData] = useState(formStatenote);
  useEffect(() => {
    if (openConfirmDate) {
      setOrderDelayDate(null);
      setOrderDate(new Date());
    }
  }, [openConfirmDate]);

  /** delete Note event*/
  const handleDeleteNote = () => {
    const payload = {
      type: collectedUncollectedListShow,
    };
    deleteNoteAction(selectedNoteDetails?.id, payload);
  };
  useEffect(() => {
    if (deleteSingleNote?.data?.success) {
      setDeleteNoteData(false);
      setNoteId("");
      setNoteValue("");
    }
  }, [deleteSingleNote?.data?.success]);

  useEffect(() => {
    if (addAndUpdateNote?.data?.success) {
      setShowTextField(false);
      setNoteValue(addAndUpdateNote?.data?.data?.note);
    }
  }, [addAndUpdateNote?.data?.success]);
  /** Set note useEffect */
  useEffect(() => {
    setNoteData({
      ...noteData,
      note: selectedNoteDetails?.note || "",
    });
  }, [showTextField]);

  useEffect(() => {
    setNoteValue(selectedNoteDetails?.note);
  }, [selectedNoteDetails]);
  /**get data on open */
  useEffect(() => {
    if (open) {
      let payload = {
        type: "un_collected",
      };
      collectionViewRxAction(collectAndUncollectedViewRxDetails, payload);
    }
    // clear error once dailog closes
    if (open === false) {
      setError(false);
      setDateValidetionErrorStatus(false);
    }
  }, [open]);

  useEffect(() => {
    setList(collectionViewRxDetails?.data?.patient_medications);
  }, [collectionViewRxDetails?.data?.patient_medications, list]);

  /** handle set collect and remove  */
  useEffect(() => {
    setCollect(tempCollected);
    setRemoved(tempRemoved);
  });

  const collectedSchema = yup.object().shape({
    discontinue_number: yup
      .number()
      .nullable(true)
      .min(1, "The number must must be greater than 0."),
    collected_number: yup
      .number()
      .nullable(true)
      .min(1, "The number must must be greater than 0."),
  });

  /** handle collect medication */
  const handleCollectMedication = (item, type, index, ordertype) => {
    let temp = list.filter((item) => {
      if (item.status === "Not collected") {
        return item;
      }
    });
    if (medicationErrorStatus) {
      setMedicationErrorStatus(false);
    }
    if (type === "delete") {
      if (collectMedication.find((items) => items?.id == item?.id)) {
        let tempCollectArr = collectMedication.filter(
          (data) => data?.id !== item?.id
        );
        setCollectMedication(tempCollectArr);
      }
      if (deleteMedication.find((items) => items == item?.id)) {
        let tempDeleteArr = deleteMedication.filter(
          (data) => data !== item?.id
        );
        setDeleteMedication(tempDeleteArr);
      } else {
        if (isCheckAll) {
          setIsCheckAll(false);
        }
        setDeleteMedication([...deleteMedication, item?.id]);
      }
    } else {
      if (deleteMedication.find((items) => items == item?.id)) {
        let tempDeleteArr = deleteMedication.filter(
          (data) => data !== item?.id
        );
        setDeleteMedication(tempDeleteArr);
      }
      if (collectMedication.find((items) => items?.id == item?.id)) {
        let tempCollectArr = collectMedication.filter(
          (data) => data?.id !== item?.id
        );
        setCollectMedication(tempCollectArr);
        if (isCheckAll) {
          setIsCheckAll(false);
        }
      } else {
        let tempData = [...collectMedication, item?.id];
        if (tempData.length === temp.length) {
          setIsCheckAll(true);
        }
        setCollectMedication([
          ...collectMedication,
          { id: item?.id, date: item?.arrived_date },
        ]);
      }
    }
  };
  /** handle add collect */
  const handleAddCollection = (formValues) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    collectMedicationAction();
    setOpen(false);
    // }
  };

  const { guardedSubmit: xssGuardedCollect } = useXssGuard(handleAddCollection);


  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setFieldValue,
    handleBlur,

  } = useFormik({
    background: "transparent !important",
    initialValues: { ...formState },
    enableReinitialize: true,
    onSubmit: xssGuardedCollect,
    validationSchema: collectedSchema,
  });
  /** handle note schema  */
  const addNoteSchema = yup.object().shape({
    note: yup.string().required("The note is required."),
  });

  /** handle add and update note */
  const handleAddAndUpdateNote = (formValues) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    const payload = {
      note: formValues?.note,
      type: collectedUncollectedListShow,
    };
    addAndUpdateNoteAction(selectedNoteDetails?.id, payload);
    // }
  };
  /** Set note useEffect */

  const {
    handleSubmit: handleSubmitNote,
    handleChange: handleChangeNote,
    values: valuesNote,
    errors: errorsNote,
    touched: touchedNote,
    handleBlur: handleBlurNote,
    resetForm: resetFormNote,
    setErrors: setErrorsNote,
  } = useFormik({
    initialValues: { ...noteData },
    enableReinitialize: true,
    validationSchema: addNoteSchema,
    onSubmit: handleAddAndUpdateNote,
  });

  let temp = collectionViewRxDetails?.data?.number_of_medication;
  let count = temp - collect - removed;
  /** handle submit collect data */
  const submitCollectData = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    if (collectionViewRxDetails?.data?.medication_type === "number") {
      if (values.collected_number === "" && values.discontinue_number === "") {
        setCollectedErrorStatus(true);
      } else {
        collectMedicationAction();
      }
    }
    if (
      collectionViewRxDetails?.data?.medication_type === "specific" ||
      collectionViewRxDetails?.data?.medication_type === "unspecific"
    ) {
      let oldList = collectionViewRxDetails?.data?.patient_medications;
      oldList = oldList?.map((item) => {
        if (item?.status === "Removed" || item?.status === "Collected") {
          return {
            id: item?.id,
          };
        } else {
          return null;
        }
      });
      let final = oldList.filter((value) => value != null);
      let temp = deleteMedication?.length + final?.length;
      let tempCollect = collectMedication?.length;

      if (collectMedication.length > 0 || deleteMedication.length > 0) {
        if (deleteMedication.length > 0) {
          setOpenMedicationRemoveConfirm(true);
          setMediCount(temp);
          setMediCollectedCount(tempCollect);
          setTotalMedi(
            collectionViewRxDetails?.data?.patient_medications.length
          );
        } else {
          // if (
          //   isCheckAll &&
          //   collectionViewRxDetails.data.is_repeat_order === true
          // ) {
          //   // setOpenConfirmDate(true);
          // } else {
          collectMedicationAction(deleteMedication);
          // }
        }
      } else {
        setMedicationErrorStatus(true);
      }
    }
    // }
  };

  /** handle collect medication action */
  const collectMedicationAction = (deleteObj) => {
    if (collectionViewRxDetails?.data?.medication_type === "unspecific") {
      let payload = {};
      if (collectMedication.length > 0) {
        payload = {
          medication_type: "unspecific",
          collected: collectMedication,
        };
      }
      if (deleteObj?.length > 0) {
        payload["removed"] = deleteObj;
        payload.medication_type = "specific";
      }
      if (nextOrderDate) {
        payload.order_delay_date = moment(new Date(nextOrderDate)).format(
          "YYYY-MM-DD"
        );
      }
      collectedAndRemovedMedicationAction(
        collectionViewRxDetails?.data?.id,
        payload
      );
    } else {
      let payload = {};
      if (collectionViewRxDetails?.data?.medication_type === "number") {
        if (
          values?.collected_number != null ||
          values?.discontinue_number != null
        ) {
          let tempCount = values?.discontinue_number + values?.collected_number;

          if (count >= tempCount) {
            payload.medication_type = "number";
            setRemovedErrorStatus(0);
            if (
              values?.collected_number !== null &&
              values?.collected_number !== ""
            ) {
              payload.collected_number = values?.collected_number;
            }
            if (
              values?.discontinue_number !== null &&
              values?.discontinue_number !== ""
            ) {
              payload.discontinue_number = values?.discontinue_number;
            }
          } else {
            setRemovedErrorStatus(2);
          }
        } else {
          setRemovedErrorStatus(1);
        }
      } else {
        if (collectMedication.length > 0) {
          payload = {
            medication_type: "specific",
            collected: collectMedication,
          };
        }
      }
      if (deleteObj?.length > 0) {
        payload["removed"] = deleteObj;
        payload.medication_type = "specific";
      }
      if (nextOrderDate) {
        payload.order_delay_date = moment(new Date(nextOrderDate)).format(
          "YYYY-MM-DD"
        );
      }

      // if (isOpenOption === true && orderDelayDate) {
      //   if (lastDrug === true) {
      //     payload.medication_type = "specific";
      //     payload.order_delay_date = moment(new Date(orderDelayDate)).format(
      //       "YYYY-MM-DD"
      //     );
      //     payload["removed"] = removeDrugList;
      //   } else {
      //     payload.order_delay_date = moment(new Date(orderDelayDate)).format(
      //       "YYYY-MM-DD"
      //     );
      //   }
      // } else {
      //   if (lastDrug === true) {
      //     payload.medication_type = "specific";
      //     payload.order_date = moment(new Date(orderDate)).format("YYYY-MM-DD");
      //     payload["removed"] = removeDrugList;
      //   } else {
      //     payload.order_date = moment(new Date(orderDate)).format("YYYY-MM-DD");
      //   }
      // }

      collectedAndRemovedMedicationAction(
        collectionViewRxDetails?.data?.id,
        payload
      );
    }
    // setOpen(false);
  };

  /** handle close */
  const handleClose = () => {
    setOpen(false);
    setMedicationErrorStatus(false);
    setCollectedErrorStatus(false);
    setOpenMedicationRemoveConfirm(false);
    setRemovedErrorStatus(0);
    setCollectMedication([]);
    setDeleteMedication([]);
    setIsCheckAll(false);
    resetForm();
    setOpenConfirmDate(false);
    setPreferredOrderLateYes(false);
    setPreferredOrderLateNo(false);
    setIsOpenOption(false);
    setIsOpenStopAndDiscontinued(false);
    setIsCheckAll(false);
    setFieldValue({
      discontinue_number: null,
      collected_number: null,
    });
    setShowTextField(false);
    if (resetCollectedAndRemovedMedicationAction) {
      resetCollectedAndRemovedMedicationAction();
    }
  };

  useEffect(() => {
    if (collectedAndRemovedData?.data?.success && isOpenDrugDialog === false) {
      handleClose();
    }
  }, [collectedAndRemovedData?.data?.success]);

  useEffect(() => {
    if (
      !collectedAndRemovedData?.loading &&
      Object.keys(collectedAndRemovedData?.data || {})?.length > 0
    ) {
      getHomeListAction();
    }
  }, [collectedAndRemovedData]);

  useEffect(() => {
    if (collectedAndRemovedData?.data?.success === true) {
      let payLoad = {};
      if (!collectionListCount?.loading) {
        if (
          selectedHeaderPharmacyId !== "" &&
          selectedHeaderPharmacyId !== "all"
        ) {
          payLoad = {
            pharmacy_id: [selectedHeaderPharmacyId],
          };
        }
        getCollectionCountAction(payLoad);
        setOpenConfirmDate(false);
      }
      setIsCheck([]);
      setOpenMedicationRemoveConfirm(false);
      setOpenConfirmDate(false);
      setPreferredOrderLateYes(false);
      setPreferredOrderLateNo(false);
      setIsOpenOption(false);
      setIsOpenStopAndDiscontinued(false);
      setIsCheckAll(false);
      resetForm();
      setMedicationErrorStatus(false);
      setCollectedErrorStatus(false);
      setRemovedErrorStatus(0);
      setCollectMedication([]);
      setDeleteMedication([]);
      setFieldValue({
        discontinue_number: null,
        collected_number: null,
      });
    }
  }, [collectedAndRemovedData?.data?.success, selectedHeaderPharmacyId]);

  useEffect(() => {
    const errors = collectedAndRemovedData?.error.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[1];
        return item;
      });
      setServerSideError(obj);
    }
  }, [collectedAndRemovedData?.error]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll === true) {
      setIsCheck([]);
      setCollectMedication([]);
    } else {
      setCollectMedication(
        list.map((li) => {
          return {
            id: li.id,
            date: li?.arrived_date
              ? li?.arrived_date
              : moment(new Date()).format("YYYY-MM-DD"),
          };
        })
      );
      setDeleteMedication([]);
    }
  };
  useEffect(() => {
    if (collectedAndRemovedData?.error?.message) {
      if (collectedAndRemovedData?.error?.errors?.order_delay_date) {
        setDateValidetionErrorStatus(true);
      } else {
        setError(true);
      }
    }
  }, [collectedAndRemovedData?.error?.message]);
  useEffect(() => {
    const drug = collectionViewRxDetails?.data?.patient_medications;
    const _validateMedication = drug?.map((item) => {
      return (item = {
        id: item?.id,
        name: item?.drug_name,
        meditation_id: item?.medication_id,
        quantity: item?.quantity,
      });
    });
    setDuplicateDrug(_validateMedication);
  }, [collectionViewRxDetails?.data?.patient_medications]);
  useEffect(() => {
    setNextOrderDate(collectionViewRxDetails?.data?.order_date);
    setMedicationfirst(true);
    setList(collectionViewRxDetails?.data?.patient_medications);
  }, [collectionViewRxDetails?.data]);

  useEffect(() => {
    if (list?.length > 0 && medicationfirst) {
      list?.forEach((item) => {
        if (item?.status == "Not collected") {
          item.arrived_date = moment(new Date()).format("YYYY-MM-DD");
        }
      });
      setMedicationfirst(false);
    }
  }, [list]);
  const handleChangeArrivedDate = (value, index) => {
    const allDrug = list;
    allDrug[index] = {
      ...allDrug[index],
      arrived_date: value,
    };
    setList([...allDrug]);
  };
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("rsDialogMain", "RSxs_modal", classes.rsDialogMainRoot)}
        sx={
          showDataBasedOnRole === "user"
            ? {
              "& .MuiDialog-paper": {
                width: collectionViewRxDetails?.data?.number_of_medication
                  ? width < 904
                    ? "75%"
                    : "75%"
                  : "100%",
              },
            }
            : {
              "& .MuiDialog-paper": {
                width: collectionViewRxDetails?.data?.number_of_medication
                  ? "50%"
                  : "100%",
              },
            }
        }
      >
        <form
          className={clsx("RsDf_form", classes.Removeborder)}
          // className="RsDf_form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Box>
            <Box
              sx={{
                "&>h2": {
                  "&>p": {
                    color: "black !important",
                    marginLeft: collectionViewRxDetails?.data
                      ?.number_of_medication
                      ? "9px"
                      : "25px",
                  },
                },
              }}
            >
              <PrimaryDialogTitle
                handleClose={handleClose}
                title="Arrived Rxs"
                icon={CollectedRXIcon}
              />
            </Box>
          </Box>

          {collectionViewRxDetails?.loading ? (
            <PageLoading />
          ) : (
            <>
              <DialogContent className="DialogContentBoxView">
                <Box
                  justifyContent={"space-between"}
                  display={"flex"}
                  // alignItems={"center"}
                  alignItems={"start"}
                >
                  <Box
                    className={
                      collectionViewRxDetails?.data?.medication_type ===
                        "number"
                        ? classes.rsPatientName
                        : classes.rsPatientNamePadding
                    }
                    style={{
                      marginLeft: collectionViewRxDetails?.data
                        ?.number_of_medication
                        ? "0px !important"
                        : "9px",
                    }}
                  >
                    <PersonIcon />
                    {capitalizeFirstLetter(collectionViewRxDetails?.data?.name)}
                    {` `}
                    {collectionViewRxDetails?.data?.last_name}
                  </Box>

                  {
                    <Box width={"166px"} paddingBottom={"20px"}>
                      <Box className={classes.orderdateMain}>
                        <CalenderIcon />
                        <Typography variant="h4">Next order date</Typography>
                      </Box>
                      <Box className={classes.orderDate}>
                        {nextOrderDate == "" || nextOrderDate == null
                          ? "-"
                          : moment(new Date(nextOrderDate)).format(
                            "DD-MM-YYYY"
                          )}
                        {!(nextOrderDate == "" || nextOrderDate == null) && (
                          <HtmlTooltipMain title="Edit">
                            <IconButton className={classes.iconBtn}>
                              <PrimaryIcon
                                color="secondary"
                                width="20px"
                                icon={EditPencleIcon}
                                cursor="pointer"
                                onClick={() => {
                                  setOpenOrderDatePicker(true);
                                }}
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                        )}
                        {/* {openOrderDatePicker && ( */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openOrderDatePicker}
                            onOpen={() => setOpenOrderDatePicker(true)}
                            onClose={() => setOpenOrderDatePicker(false)}
                            className={classes.rsDate}
                            name="order_date"
                            id="order_date"
                            views={["year", "month", "day"]}
                            inputFormat="DD-MM-YYYY (ddd)"
                            value={nextOrderDate}
                            // disablePast
                            minDate={moment().subtract(-1, "day")}
                            disabledKeyboardNavigation={false}
                            inputProps={{ readOnly: true }}
                            onChange={(newDate) => {
                              setDateValidetionErrorStatus(false);
                              setNextOrderDate(newDate);
                            }}
                            PopperProps={{
                              placement: "right-end",
                              // placement: "right",
                              // anchorEl: anchorEl
                            }}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                size="small"
                                name="order_date"
                                id="order_date"
                                {...params}
                                onClick={(e) => setOpenOrderDatePicker(true)}
                              />
                            )}
                          />
                        </LocalizationProvider>
                        {/* )} */}
                      </Box>
                    </Box>
                  }
                </Box>
                {noteValue && (
                  <Box className={classes.rsCollectionNote}>
                    <Box className={classes.rsBackground}>
                      <Typography
                        variant="h5"
                        bold
                        style={{ display: "inline" }}
                        className={classes.rsFontColor}
                      >
                        Colletion Notes:
                      </Typography>

                      <>
                        {!showTextField && noteValue && (
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            {/* <li className={classes.rsFontColor}>{noteValue}</li> */}
                            <Typography
                              variant="p"
                              className={classes.rsFontColor}
                            >
                              {noteValue}
                            </Typography>
                            <Box>
                              {!showTextField ? (
                                <HtmlTooltipMain title="Edit Note">
                                  <IconButton className={classes.iconBtnEdit}>
                                    <PrimaryIcon
                                      color="secondary"
                                      width="20px"
                                      icon={EditIcon}
                                      cursor="pointer"
                                      onClick={() => {
                                        setShowTextField(true);
                                      }}
                                    />
                                  </IconButton>
                                </HtmlTooltipMain>
                              ) : (
                                <></>
                              )}
                              {!showTextField ? (
                                <HtmlTooltipMain title="Delete Note">
                                  <IconButton
                                    className={classes.iconBtnEdit}
                                    onClick={() => {
                                      setDeleteNoteData(true);
                                      setNoteId(selectedNoteDetails?.id);
                                    }}
                                  >
                                    <PrimaryIcon
                                      width="20px"
                                      icon={DeleteIcon}
                                      cursor="pointer"
                                    />
                                  </IconButton>
                                </HtmlTooltipMain>
                              ) : (
                                <></>
                              )}
                            </Box>
                          </Box>
                        )}
                      </>

                      {showTextField && (
                        <form
                          name="showtest"
                        // onSubmit={(e) => {
                        //   // e.preventDefault();
                        //   handleSubmitNote();
                        //   var note = document.showtest.note.value;
                        //   if (note === null || note === "") {
                        //     document.getElementById("note")?.focus();
                        //   }
                        // }}
                        >
                          <Box className={classes.rsTextAreaBox}>
                            <TextareaAutosize
                              rows={5}
                              // cols={46}
                              style={{
                                width: "auto !important",
                                height: "50% !important",
                                overflow: "auto ",
                              }}
                              variant="outlined"
                              placeholder="Enter Note "
                              id="note"
                              name="note"
                              className={classes.rsTextAreaEdit}
                              value={valuesNote?.note}
                              onChange={handleChangeNote}
                              error={touchedNote?.note && errorsNote?.note}
                              helperText={touchedNote?.note && errorsNote?.note}
                              onBlur={handleBlurNote}
                            />
                            <FormHelperText
                              error={touchedNote?.note && errorsNote?.note}
                              style={{ marginBottom: "10px" }}
                            >
                              {touchedNote?.note && errorsNote?.note}
                            </FormHelperText>
                            <Button
                              children="Update"
                              className={classes.buttonStyle}
                              variant="contained"
                              color="primary"
                              onClick={(e) => {
                                // e.preventDefault();
                                handleSubmitNote();
                              }}
                              disabled={addAndUpdateNote?.loading}
                              startIcon={
                                addAndUpdateNote?.loading && (
                                  <CircularProgress color="white" size="20px" />
                                )
                              }
                            />
                          </Box>
                        </form>
                      )}
                    </Box>
                  </Box>
                )}
                {collectionViewRxDetails?.data?.medication_type === "number" ? (
                  <Box className={classes.rsBoxAlign}>
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.tableAlign}>
                          {" "}
                          {/* No. of medication ordered : */}
                          Number of medications ordered :
                        </TableCell>
                        <TableCell className={classes.textJustify}>
                          {collectionViewRxDetails?.data?.number_of_medication}
                          &nbsp;
                          {collectionViewRxDetails?.data?.patient_number_of_medication?.map(
                            (item, index) => {
                              if (item.status === "Collected") {
                                tempCollected += parseInt(
                                  item.pnom_medication_no
                                );
                              }
                              if (item.status === "Removed") {
                                tempRemoved += parseInt(
                                  item.pnom_medication_no
                                );
                              }
                              return null;
                            }
                          )}
                          {tempCollected !== 0 || tempRemoved !== 0
                            ? `(${tempCollected} Collected) ${" "}(${tempRemoved} Removed) ${" "}(${temp -
                            tempRemoved -
                            tempCollected -
                            (values?.collected_number > 0
                              ? values?.collected_number
                              : 0) -
                            (values?.discontinue_number > 0
                              ? values?.discontinue_number
                              : 0)
                            } Uncollected)`
                            : ""}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tableAlign}>
                          {" "}
                          Enter number of items arrived :
                          {/* Collected Medication : */}
                        </TableCell>

                        <TableCell className={classes.tableAlign}>
                          <TextField
                            className={classes.rsCollectedNumber}
                            // style={{
                            //   width: "25%",
                            // }}
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="number"
                            // placeholder="Collected Count"
                            // label="Collected Count"
                            name="collected_number"
                            value={values?.collected_number}
                            error={
                              touched?.collected_number &&
                              errors?.collected_number
                            }
                            // helperText={
                            //   touched?.collected_number &&
                            //   errors?.collected_number
                            // }
                            onChange={(e) => {
                              handleChange(e);
                              setRemovedErrorStatus(0);
                            }}
                            onBlur={handleBlur}
                          />
                          {errors?.collected_number && (
                            <span className={classes.rsRedTest}>
                              {touched?.collected_number &&
                                errors?.collected_number}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tableAlign}>
                          <Button
                            className={classes.rstextButton}
                            // variant="contained"
                            onClick={() => {
                              const isOpenOption = !isOpenStopAndDiscontinued;
                              setIsOpenStopAndDiscontinued(isOpenOption);
                            }}
                          >
                            Click here if any medications discontinued
                            {/* Any medications stopped or discontinued? */}
                          </Button>
                        </TableCell>
                        {isOpenStopAndDiscontinued === true && (
                          <TableCell className={classes.tableAlign}>
                            <TextField
                              className={classes.rstextFieldsize}
                              variant="outlined"
                              fullWidth
                              size="small"
                              type="number"
                              name="discontinue_number"
                              // placeholder="Discontinue Count "
                              // label="Discontinue Count  "
                              value={values?.discontinue_number}
                              error={
                                touched?.discontinue_number &&
                                errors?.discontinue_number
                              }
                              // helperText={
                              //   touched?.discontinue_number &&
                              //   errors?.discontinue_number
                              // }
                              onChange={(e) => {
                                handleChange(e);
                                setRemovedErrorStatus(0);
                              }}
                              onBlur={handleBlur}
                            />
                            {errors?.discontinue_number && (
                              <span className={classes.rsRedTest}>
                                {touched?.discontinue_number &&
                                  errors?.discontinue_number}
                              </span>
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    </TableBody>
                  </Box>
                ) : collectionViewRxDetails?.data?.medication_type ===
                  "unspecific" ? (
                  // <Box
                  //   style={{
                  //     width: "100%",
                  //     display: "flex",
                  //     justifyContent: "center",
                  //     alignItems: "center",
                  //   }}
                  // >
                  //   <Box
                  //     style={{
                  //       display: "flex",
                  //       justifyContent: "center",
                  //       marginBottom: "20px",
                  //       background: "#EECA3C6B",
                  //       border: "1px solid #EECA3C",
                  //       width: "30%",
                  //       padding: "5px 0px",
                  //     }}
                  //   >
                  //     <Typography
                  //       variant="h4"
                  //       style={{
                  //         color: "black",
                  //       }}
                  //     >
                  //       Medications are Unspecific.
                  //     </Typography>
                  //   </Box>
                  // </Box>
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.rsheader}>
                            MEDICINE
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell className={classes.rsheader}>
                            QUANTITY
                          </TableCell>
                          <TableCell className={classes.alignmentCheck}>
                            <Box className="ArrivedBoxTh">
                              <Checkbox
                                checked={isCheckAll}
                                onChange={() => {
                                  handleSelectAll();
                                }}
                              />
                              ARRIVED
                              {/* COLLECTED */}
                            </Box>
                          </TableCell>
                          <TableCell
                            style={{
                              whiteSpace: "nowrap",
                              zIndex: "5",
                              width: "150px",
                            }}
                          >
                            ARRIVED ON
                          </TableCell>
                          <TableCell className={classes.rsDeleteText}>
                            DELETE
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        style={{
                          backgroundColor: "#FAF4F4",
                        }}
                      >
                        {list?.map((item, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell
                              // semiBold
                              >
                                <Grid xs={12} className={classes.rsAlign}>
                                  {" "}
                                  <Grid
                                    xs={9}
                                    style={{
                                      marginTop: "13px",
                                      marginBottom: "11px",
                                      fontSize: "20px",
                                      fontWeight: "400",
                                      color: "black",
                                    }}
                                  >
                                    {" "}
                                    {item?.drug_name}
                                  </Grid>
                                </Grid>
                              </TableCell>
                              <TableCell className={classes.rsTextColor}>
                                -
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Collected" && (
                                    <Checkbox checked={true} disabled={true} />
                                  )}
                                  {item?.status === "Removed" && "-"}
                                  {item?.status === "Not collected" && (
                                    <Checkbox
                                      checked={collectMedication.some(
                                        (value) => value.id == item.id
                                      )}
                                      onChange={(e) => {
                                        handleCollectMedication(
                                          item,
                                          "collect",
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Not collected" &&
                                    !deleteMedication.includes(item.id) && (
                                      <Box className={classes.rsCollectedDate}>
                                        {collectMedication.some(
                                          (value) => value.id === item.id
                                        )
                                          ? moment(
                                            new Date(
                                              item.arrived_date
                                                ? item?.arrived_date
                                                : item?.updated_at
                                            )
                                          ).format("DD-MM-YYYY") || "N / A"
                                          : "-"}
                                        {collectMedication.find(
                                          (value) => value.id == item.id
                                        ) && (
                                            <Box display={"flex"}>
                                              <HtmlTooltipMain title="Edit">
                                                <IconButton
                                                  className={classes.iconBtn}
                                                >
                                                  <PrimaryIcon
                                                    color="secondary"
                                                    width="20px"
                                                    icon={EditPencleIcon}
                                                    cursor="pointer"
                                                    onClick={() => {
                                                      setOpenArriedDatePicker(
                                                        index
                                                      );
                                                    }}
                                                  />
                                                </IconButton>
                                              </HtmlTooltipMain>
                                              <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                              >
                                                <DatePicker
                                                  open={
                                                    openArriedDatePicker == index
                                                  }
                                                  onOpen={() =>
                                                    setOpenArriedDatePicker(index)
                                                  }
                                                  onClose={() =>
                                                    setOpenArriedDatePicker(null)
                                                  }
                                                  className={classes.rsArrived}
                                                  name="order_date"
                                                  id="order_date"
                                                  views={["year", "month", "day"]}
                                                  inputFormat="DD-MM-YYYY (ddd)"
                                                  value={item?.arrived_date}
                                                  // disablePast
                                                  disabledKeyboardNavigation={
                                                    false
                                                  }
                                                  inputProps={{ readOnly: true }}
                                                  onChange={(newDate) => {
                                                    handleChangeArrivedDate(
                                                      newDate,
                                                      index
                                                    );

                                                    setCollectMedication((prev) =>
                                                      prev.map((medication) =>
                                                        medication.id === item?.id
                                                          ? {
                                                            ...medication,
                                                            date: moment(
                                                              new Date(newDate)
                                                            ).format(
                                                              "YYYY-MM-DD"
                                                            ),
                                                          }
                                                          : medication
                                                      )
                                                    );

                                                    // setMedication(newDate);
                                                  }}
                                                  PopperProps={{
                                                    placement: "right-end",
                                                    // placement: "right",
                                                    // anchorEl: anchorEl
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      fullWidth
                                                      size="small"
                                                      name="order_date"
                                                      id="order_date"
                                                      {...params}
                                                      onClick={(e) =>
                                                        setOpenArriedDatePicker(
                                                          index
                                                        )
                                                      }
                                                    />
                                                  )}
                                                />
                                              </LocalizationProvider>
                                            </Box>
                                          )}
                                      </Box>
                                    )}
                                  {item?.status === "Collected" && (
                                    <Box className={classes.rsCollectedDate}>
                                      {" "}
                                      {moment(new Date(item.updated_at)).format(
                                        "DD-MM-YYYY"
                                      ) || "N / A"}
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Collected" && "-"}
                                  {item?.status === "Not collected" && (
                                    <Checkbox
                                      checked={deleteMedication.includes(
                                        item.id
                                      )}
                                      onChange={() =>
                                        handleCollectMedication(item, "delete")
                                      }
                                      checkedIcon={
                                        <CrossIcon
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                            borderRadius: "2px",
                                            marginLeft: "3px",
                                          }}
                                        />
                                      }
                                    />
                                  )}
                                  {item?.status === "Removed" && (
                                    <Chip
                                      label={item?.status}
                                      variant="outlined"
                                      style={{
                                        backgroundColor:
                                          "rgba(233, 81, 78, 0.2)",
                                        border: "0.5px solid rgb(233, 81, 78)",
                                        color: "#E9514E",
                                        borderRadius: "5px",
                                        width: "90px",
                                      }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.rsheader}>
                            MEDICINE
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell className={classes.rsheader}>
                            QUANTITY
                          </TableCell>
                          <TableCell className={classes.alignmentCheck}>
                            <Box className="ArrivedBoxTh">
                              <Checkbox
                                checked={isCheckAll}
                                onChange={() => {
                                  handleSelectAll();
                                }}
                              />
                              ARRIVED
                              {/* COLLECTED */}
                            </Box>
                          </TableCell>
                          <TableCell
                            style={{
                              whiteSpace: "nowrap",
                              zIndex: "5",
                              width: "150px",
                            }}
                          >
                            ARRIVED ON
                          </TableCell>
                          <TableCell className={classes.rsDeleteText}>
                            DELETE
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        style={{
                          backgroundColor: "#FAF4F4",
                        }}
                      >
                        {list?.map((item, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell
                                // semiBold
                                className={clsx(classes.rsOrderDate)}
                              >
                                <Grid xs={12} className={classes.rsAlign}>
                                  {" "}
                                  <Grid
                                    xs={9}
                                    style={{
                                      marginTop: "13px",
                                      marginBottom: "11px",
                                      fontWeight: "600",
                                      color: "#5A6872",
                                    }}
                                  >
                                    {" "}
                                    {item?.drug_name}
                                  </Grid>
                                  <Grid xs={3}>
                                    <IconButton
                                      className={classes.rseditDateIcon}
                                    >
                                      <PrimaryIcon
                                        color="secondary"
                                        width="20px"
                                        icon={EditIcon}
                                        cursor="pointer"
                                        onClick={() => {
                                          // setIsOrderRecordActionType("editOrderDate");
                                          setEditDrugName(item);
                                          setIsOpenDrugDialog(true);
                                          // setIsOpenEditDobModel(true);
                                        }}
                                      />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </TableCell>
                              {/* <TableCell></TableCell> */}
                              <TableCell className={classes.rsTextColor}>
                                {item?.quantity}
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Collected" && (
                                    <Checkbox checked={true} disabled={true} />
                                  )}
                                  {item?.status === "Removed" && "-"}
                                  {item?.status === "Not collected" && (
                                    <Checkbox
                                      checked={collectMedication.some(
                                        (value) => value.id == item.id
                                      )}
                                      onChange={(e) => {
                                        handleCollectMedication(
                                          item,
                                          "collect",
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Not collected" &&
                                    !deleteMedication.includes(item.id) && (
                                      <Box className={classes.rsCollectedDate}>
                                        {collectMedication.some(
                                          (value) => value.id === item.id
                                        )
                                          ? moment(
                                            new Date(
                                              item.arrived_date
                                                ? item?.arrived_date
                                                : item?.updated_at
                                            )
                                          ).format("DD-MM-YYYY") || "N / A"
                                          : "-"}
                                        {/* {moment(
                                          new Date(
                                            item.arrived_date
                                              ? item?.arrived_date
                                              : item?.updated_at
                                          )
                                        ).format("DD-MM-YYYY") || "N / A"} */}
                                        {collectMedication.find(
                                          (value) => value.id == item.id
                                        ) && (
                                            <Box display={"flex"}>
                                              <HtmlTooltipMain title="Edit">
                                                <IconButton
                                                  className={classes.iconBtn}
                                                >
                                                  <PrimaryIcon
                                                    color="secondary"
                                                    width="20px"
                                                    icon={EditPencleIcon}
                                                    cursor="pointer"
                                                    onClick={() => {
                                                      setOpenArriedDatePicker(
                                                        index
                                                      );
                                                    }}
                                                  />
                                                </IconButton>
                                              </HtmlTooltipMain>
                                              <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                              >
                                                <DatePicker
                                                  open={
                                                    openArriedDatePicker == index
                                                  }
                                                  onOpen={() =>
                                                    setOpenArriedDatePicker(index)
                                                  }
                                                  onClose={() =>
                                                    setOpenArriedDatePicker(null)
                                                  }
                                                  className={classes.rsArrived}
                                                  name="order_date"
                                                  id="order_date"
                                                  views={["year", "month", "day"]}
                                                  inputFormat="DD-MM-YYYY (ddd)"
                                                  value={item?.arrived_date}
                                                  // disablePast
                                                  disabledKeyboardNavigation={
                                                    false
                                                  }
                                                  inputProps={{ readOnly: true }}
                                                  onChange={(newDate) => {
                                                    handleChangeArrivedDate(
                                                      newDate,
                                                      index
                                                    );

                                                    setCollectMedication((prev) =>
                                                      prev.map((medication) =>
                                                        medication.id === item?.id
                                                          ? {
                                                            ...medication,
                                                            date: moment(
                                                              new Date(newDate)
                                                            ).format(
                                                              "YYYY-MM-DD"
                                                            ),
                                                          }
                                                          : medication
                                                      )
                                                    );

                                                    // setMedication(newDate);
                                                  }}
                                                  PopperProps={{
                                                    placement: "right-end",
                                                    // placement: "right",
                                                    // anchorEl: anchorEl
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      fullWidth
                                                      size="small"
                                                      name="order_date"
                                                      id="order_date"
                                                      {...params}
                                                      onClick={(e) =>
                                                        setOpenArriedDatePicker(
                                                          index
                                                        )
                                                      }
                                                    />
                                                  )}
                                                />
                                              </LocalizationProvider>
                                            </Box>
                                          )}
                                      </Box>
                                    )}
                                  {item?.status === "Collected" && (
                                    <Box className={classes.rsCollectedDate}>
                                      {" "}
                                      {moment(new Date(item.updated_at)).format(
                                        "DD-MM-YYYY"
                                      ) || "N / A"}
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box className={classes.align}>
                                  {item?.status === "Collected" && "-"}
                                  {item?.status === "Not collected" && (
                                    <Checkbox
                                      checked={deleteMedication.includes(
                                        item.id
                                      )}
                                      onChange={() =>
                                        handleCollectMedication(item, "delete")
                                      }
                                      checkedIcon={
                                        <CrossIcon
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                            borderRadius: "2px",
                                            marginLeft: "3px",
                                          }}
                                        />
                                      }
                                    />
                                  )}
                                  {item?.status === "Removed" && (
                                    <Chip
                                      label={item?.status}
                                      variant="outlined"
                                      style={{
                                        backgroundColor:
                                          "rgba(233, 81, 78, 0.2)",
                                        border: "0.5px solid rgb(233, 81, 78)",
                                        color: "#E9514E",
                                        borderRadius: "5px",
                                        width: "90px",
                                      }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                {removedErrorStatus === 1 && (
                  <span className={classes.medicationErrorMessage}>
                    Please add at-least one Collected Medication or Stopped and
                    discontinued?
                  </span>
                )}
                {removedErrorStatus === 2 && (
                  <span className={classes.medicationErrorMessage}>
                    The total No of medication counts is less than the Collected
                    Medication and Stopped and discontinue.
                  </span>
                )}
                {collectedErrorStatus && (
                  <span className={classes.medicationErrorMessage}>
                    {" "}
                    Please collected or discontinued the medication{" "}
                  </span>
                )}
                {medicationErrorStatus && (
                  <span className={classes.medicationErrorMessage}>
                    Please select medication
                  </span>
                )}
                {dateValidetionErrorStatus && (
                  <span className={classes.medicationErrorMessage}>
                    The next order date must be a date after today.
                  </span>
                )}
                {error && (
                  <span className={classes.medicationErrorMessage}>
                    {collectedAndRemovedData?.error?.message}
                  </span>
                )}
              </DialogContent>
              <DialogActions className={classes.rsBtnMain}>
                <Button
                  className="BtnGreen"
                  variant="contained"
                  onClick={() => {
                    submitCollectData();
                  }}
                  disabled={collectedAndRemovedData?.loading}
                >
                  {collectedAndRemovedData?.loading && (
                    <CircularProgress
                      color="white"
                      size="15px"
                      style={{ marginRight: "10px" }}
                    />
                  )}
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleClose()}
                  className="BtnGray"
                >
                  Cancel
                </Button>
              </DialogActions>
            </>
          )}
        </form>
      </Dialog>
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
      <RemoveMedicationConfirmationDialog
        open={openMedicationRemoveConfirm}
        setOpen={setOpenMedicationRemoveConfirm}
        collectionViewRxDetails={collectionViewRxDetails}
        deleteMedication={deleteMedication}
        deleteMedicationAction={collectMedicationAction}
        collectAndRemoveData={collectedAndRemovedData}
        mediCount={mediCount}
        setMediCount={setMediCount}
        totalMedi={totalMedi}
        setTotalMedi={setTotalMedi}
        setOpenConfirmDate={setOpenConfirmDate}
        setLastDrug={setLastDrug}
        setRemoveDrugList={setRemoveDrugList}
        lastDrug={lastDrug}
        removeDrugList={removeDrugList}
        mediCollectedCount={mediCollectedCount}
      />
      <ConfirmDateCollectedDialog
        open={openConfirmDate}
        setOpen={setOpenConfirmDate}
        actionBtnTitle={"Submit"}
        preferredOrderLateYes={preferredOrderLateYes}
        setPreferredOrderLateYes={setPreferredOrderLateYes}
        preferredOrderLateNo={preferredOrderLateNo}
        setPreferredOrderLateNo={setPreferredOrderLateNo}
        collectMedicationAction={collectMedicationAction}
        isOpenOption={isOpenOption}
        setIsOpenOption={setIsOpenOption}
        collectionViewRxDetails={collectionViewRxDetails}
        setOrderDelayDate={setOrderDelayDate}
        orderDelayDate={orderDelayDate}
        orderDate={orderDate}
        setOrderDate={setOrderDate}
        setFieldValue={setFieldValue}
        errors={errors}
        touched={touched}
        serverSideErrors={serverSideErrors}
        setServerSideError={setServerSideError}
        setLastDrug={setLastDrug}
        setRemoveDrugList={setRemoveDrugList}
        lastDrug={lastDrug}
        removeDrugList={removeDrugList}
      />
      <EditDrugDialog
        open={isOpenDrugDialog}
        setOpen={setIsOpenDrugDialog}
        editData={editDrugName}
        setEditData={setEditDrugName}
        collectionViewRxAction={collectionViewRxAction}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
        medications={duplicateDrug}
        setMedication={setMedication}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <ConfirmationDialog
        open={deleteNoteData}
        setOpen={setDeleteNoteData}
        title="Are you sure?"
        body="You wan't be able to undo this note!"
        handleSubmit={handleDeleteNote}
        actionBtnTitle="Yes Delete It!!"
        loading={deleteSingleNote?.loading}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  collectAndRemoveData: state.collection.collectAndRemoveData,
  collectedAndRemovedData: state.collection.collectedAndRemovedData,
  collectionListCount: state.collection.collectionListCount,
});
const mapDispatchToProps = (dispatch) => ({
  collectAndRemoveMedicationAction: (id, payload) =>
    dispatch({ type: START_COLLECT_AND_REMOVE_MEDICATION, id, payload }),
  collectedAndRemovedMedicationAction: (id, payload) =>
    dispatch({ type: START_COLLECTED_AND_REMOVED_MEDICATION, id, payload }),
  getCollectionCountAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_COUNT, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  deleteNoteAction: (id, payload) =>
    dispatch({ type: START_DELETE_NOTE, id, payload }),
  resetCollectedAndRemovedMedicationAction: () =>
    dispatch({ type: RESET_COLLECTED_AND_REMOVED_MEDICATION }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectDialog);
